"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataInJs = dataInJs;
function dataInJs() {
  var data = [{
    country: "美国",
    value: [-73.97622, 40.757498]
  }, {
    country: "加拿大",
    value: [-109.404347, 60.638178]
  }, {
    country: "澳大利亚",
    value: [137.708144, -25.328065]
  }, {
    country: "中国",
    value: [116.512885, 39.847469]
  }, {
    country: "新加坡",
    value: [103.413384, 1.910925]
  }, {
    country: "瑞士",
    value: [7.44716, 46.950139]
  }, {
    country: "德国",
    value: [13.40498, 52.521199]
  }, {
    country: "波兰",
    value: [13.40498, 52.521199]
  }, {
    country: "丹麦",
    value: [12.431735, 55.665973]
  }, {
    country: "俄罗斯",
    value: [37.621612, 55.758257]
  }, {
    country: "法国",
    value: [2.333696, 48.865244]
  }, {
    country: "英国",
    value: [-0.130058, 51.508604]
  }, {
    country: "芬兰",
    value: [24.935506, 60.173495]
  }, {
    country: "荷兰",
    value: [4.89354, 52.370649]
  }, {
    country: "瑞士",
    value: [7.44716, 46.950139]
  }, {
    country: "意大利",
    value: [12.491267, 41.904612]
  }];
  return data;
  // Add more countries and capitals here
}